import __request__ from "routing/request";
export function getArchives(paginationparameters, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.datalake/data_lake", paginationparameters, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteRestoredArchive(streamId, restoredOperationId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.datalake/data_lake/archive/${streamId}/retrieved/${restoredOperationId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function addMultipleMessagesToInvestigation(request, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.datalake/data_lake/investigations/add_data_lake_messages", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(stream_ids, from, to, full_delete, wipe_restores, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.datalake/data_lake/jobs/delete", stream_ids, { "from": from, "to": to, "full_delete": full_delete, "wipe_restores": wipe_restores }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function progress(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.datalake/data_lake/jobs/progress", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function progressBystreamId(streamId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.datalake/data_lake/jobs/progress/${streamId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function retrieveBulkRetrievalRequest(retrieval_bulk_request, from, to, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.datalake/data_lake/jobs/retrieve", retrieval_bulk_request, { "from": from, "to": to }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function retrieveMultipleMessages(request, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.datalake/data_lake/jobs/retrieve_messages_by_id", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function cancel(jobId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.datalake/data_lake/jobs/${jobId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function restoreEstimate(stream_ids, from, to, data_lake_id, inclusion_type = "BOTH", field_filters, operator = "AND", requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.datalake/data_lake/size_estimate", field_filters, { "data_lake_id": data_lake_id, "stream_ids": stream_ids, "from": from, "to": to, "inclusion_type": inclusion_type, "operator": operator }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getDataLakeStreams(paginationparameters, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.datalake/data_lake/stream", paginationparameters, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getStreamConfigs(streamId, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.datalake/data_lake/stream/config", streamId, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function toggleConfigEnableStatus(enable, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.datalake/data_lake/stream/config/enable", enable, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getEnabledStreamStatuses(stream_ids, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.datalake/data_lake/stream/status", stream_ids, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getDataLakeArchive(streamId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.datalake/data_lake/stream/${streamId}/archive`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getStreamConfig(streamId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.datalake/data_lake/stream/${streamId}/config`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function optimize(streamId, action, target_file_size_bytes = 0, retain_last_num_snapshots = 0, expire_snapshots_older_than, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.datalake/data_lake/stream/${streamId}/optimize/${action}`, null, { "target_file_size_bytes": target_file_size_bytes, "retain_last_num_snapshots": retain_last_num_snapshots, "expire_snapshots_older_than": expire_snapshots_older_than }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function setArchiveRetentionTime(streamId, retention_time_change_request, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.datalake/data_lake/stream/${streamId}/retention_time`, retention_time_change_request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getEnabledStatus(streamId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.datalake/data_lake/stream/${streamId}/status`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
